import { render, staticRenderFns } from "./practitioner.vue?vue&type=template&id=c6a1df98&"
import script from "./practitioner.vue?vue&type=script&lang=js&"
export * from "./practitioner.vue?vue&type=script&lang=js&"
import style0 from "./practitioner.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports